import { defineEffect } from '../../../core/effect';
import { negateBank } from '../fx/negateBank';

/**
 * **効果の無効**（Issue #591 v1。指示書 `../direction/chain_negated.md`。キービジュアルは無い＝方向は人が決めた）。
 * 無効にされたカードを中央に大きく出し、**イラストの側に横の細い鎖 2 本**で縛って無効化の印を叩きつける。
 * 組み立ては発動の無効（`chain_negated.js`）と共有（`../fx/negateBank.js`）。違うのは鎖の見た目だけ。
 */
export default defineEffect(negateBank({
  situation: 'chain_disabled',
  role: 'effect',
  label: '効果の無効（横の細い鎖 2 本で縛って無効化の印）',
  color: '#b0102a',
  bind: 'disabled',
}), 'chain_disabled_effect.js');
